import axios from 'axios';
import { AppConfig, JWT, RT_TOKEN } from '../config';
import { CompanyConstant } from './constants/CompanyConstant';
import { AlertAction } from './AlertAction';
import { Translate as t } from '../config/Translate';
import { getParents } from '../lib/companyHierarchyService';

const GetCompany = () => async (dispatch) => {
	try {
		const ret = await axios.get(AppConfig.API_SERVER_PATH + '/company', JWT());

		if (ret.data.status == 'success') {
			dispatch({ type: CompanyConstant.GET_COMPANYLIST, companies: ret.data.data });
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		console.error("CompanyAction.GetCompany error:", error);
		dispatch(AlertAction.ErrorMsg("Failed to load companies"));
	}
	
	// const partners = await GetAllPartners();

	// if (partners.length > 0) {
	// 	const data = partners.map(x => {
	// 		return {
	// 			operator: x?.ops,
	// 			alias: x?.alias,
	// 			contactEmail: x?.cemail,
	// 			contactHp: x?.chp,
	// 			contactTel: x?.ctel,
	// 			contactFax: x?.cfax,
	// 			contactWebsite: x?.cweb,
	// 			createDate: x?.cd,
	// 			updateDate: x?.ud,
	// 			isDel: x?.isDel,
	// 			_id: x?._id,
	// 			companyId: x?.cId,
	// 			name: x?.nm,
	// 			country: x?.cnty,
	// 			org: x?.otype,
	// 			address: x?.address,
	// 			addressExtra: x?.addext,
	// 			state: x?.state,
	// 			zip: x?.zip,
	// 			region: x?.region,
	// 			note: x?.note,
	// 			ownername: x?.oname,
	// 			ownerhp: x?.ohp,
	// 			owneremail: x?.omail,
	// 			timezone: x?.tz,
	// 			lat: x?.coords?.length > 0 ? x.coords[0] : '',
	// 			lng: x?.coords?.length > 0 ? x.coords[1] : '',
	// 			parentCompanyId: x?.prntId,
	// 			companyTWId: x?.twId,
	// 			scp_1: parseInt(x?.sk?.replace('scp:', '').split(':')[0]),
	// 			scp_2: parseInt(x?.sk?.replace('scp:', '').split(':')[1]),
	// 			scp_3: parseInt(x?.sk?.replace('scp:', '').split(':')[2]),
	// 			updater: x?.ud
	// 		}
	// 	}).sort((a, b) => {
	// 		if (a.scp_1 === b.scp_1) {
	// 			if (a.scp_2 === b.scp_2)
	// 				return (a.scp_3 < b.scp_3) ? -1 : (a.scp_3 > b.scp_3) ? 1 : 0;
	// 			else
	// 				return (a.scp_2 < b.scp_2) ? -1 : 1;
	// 		} else {
	// 			return (a.scp_1 < b.scp_1) ? -1 : 1;
	// 		}
	// 	});

	// 	dispatch({ type: CompanyConstant.GET_COMPANYLIST, companies: data });
	// } else {
	// 	dispatch(AlertAction.Error(ret.data));
	// }

	
};

const GetCompanyByToken = (token) => async (dispatch) => {
	try {
		const ret = await axios.get(AppConfig.API_SERVER_PATH + '/company', { headers: { token } });
		if (ret.data.status == 'success') {
			dispatch({ type: CompanyConstant.GET_COMPANYLIST, companies: ret.data.data });
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		console.error("CompanyAction.GetCompanyByToken error:", error);
		dispatch(AlertAction.ErrorMsg("Failed to load companies"));
	}
};

const GetCompanyInfo = (companyId) => async (dispatch) => {
	try {
		const ret = await axios.get(AppConfig.API_SERVER_PATH + '/company/' + companyId, JWT());

		if (ret.data.status == 'success') {
			dispatch({ type: CompanyConstant.GET_COMPANY, company: ret.data.data });
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		console.error("CompanyAction.GetCompanyInfo error:", error);
		dispatch(AlertAction.ErrorMsg("Failed to load company info"));
	}

	// const partners = await GetAllPartners();
	// const partnerInfo = partners.find(x => x.cId === companyId);
	// const scp = partnerInfo?.sk?.replace('scp:', '');

	// const response = await axios.get(`${AppConfig.GROUP_API_PATH}/partner/${scp}`, RT_TOKEN());

	// if (response.data.status === 'success' && response.data.data.length > 0) {
	// 	const result = response.data.data[0];
	// 	const data = {
	// 		operator: result.ops,
	// 		alias: result.alias,
	// 		contactEmail: result.cemail,
	// 		contactHp: result.chp,
	// 		contactTel: result.ctel,
	// 		contactFax: result.cfax,
	// 		contactWebsite: result.cweb,
	// 		createDate: result.cd,
	// 		updateDate: result.ud,
	// 		isDel: result.isDel,
	// 		_id: result._id,
	// 		companyTWId: result.twId,
	// 		companyId: result.cId,
	// 		name: result.nm,
	// 		country: result.cnty,
	// 		org: result.otype,
	// 		address: result.address,
	// 		addressExtra: result.addext,
	// 		state: result.state,
	// 		zip: result.zip,
	// 		region: result.region,
	// 		note: result.note,
	// 		ownername: result?.oname,
	// 		ownerhp: result?.ohp,
	// 		owneremail: result?.omail,
	// 		timezone: result?.tz,
	// 		lat: result?.coords?.length > 0 ? result.coords[0] : 0,
	// 		lng: result?.coords?.length > 0 ? result.coords[1] : 0,
	// 		parentCompanyId: result.prntId,
	// 		scp: result.sk?.replace('scp:', '')
	// 	}

	// 	dispatch({ type: CompanyConstant.GET_COMPANY, company: data });
	// }
	// else {
	// 	dispatch(AlertAction.Error(ret.data));
	// }
};

const AddCompanyInfo = (companyInfo) => async (dispatch) => {
	try {
		const data = {
			who: JSON.parse(localStorage.getItem('user')).adminid,
			type: "create",
			data: companyInfo,
		};
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/company', data, JWT());

		if (ret.data.status == 'success') {
			dispatch(AlertAction.Success(t('common.message.success.saved')));
			dispatch({ type: CompanyConstant.ADD_COMPANYINFO, company: ret.data.data });
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		console.error("CompanyAction.AddCompanyInfo error:", error);
		dispatch(AlertAction.Error(error));
	}
};


const UpdateCompanyInfo = (companyId, companyInfo) => async (dispatch) => {
	try {
		const data = {
			who: JSON.parse(localStorage.getItem('user')).adminid,
			type: 'update',
			data: companyInfo,
		};

		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/company/' + companyId, data, JWT());
		if (ret.data.status == 'success') {
			dispatch(AlertAction.Success(t('common.message.success.saved')));
			dispatch({ type: CompanyConstant.UPDATE_COMPANYINFO, company: ret.data.data });
			return true;
		} else {
			dispatch(AlertAction.Error(ret.data));
			return false;
		}
	} catch (error) {
		console.error("CompanyAction.UpdateCompanyInfo error:", error);
		dispatch(AlertAction.Error(error));
		return false;
	}
};


const DeleteCompany = (companyId) => async (dispatch) => {
	try {
		const data = {
			"who": JSON.parse(localStorage.getItem("user")).adminid,
			"type": "delete"
		}
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/company/' + companyId, data, JWT());
		if (ret.data.status == 'success') {
			dispatch(AlertAction.Success(t('common.message.deleted')));
			dispatch({ type: CompanyConstant.DELETE_COMPANY, delcompanyid: companyId });
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		console.error("CompanyAction.DeleteCompany error:", error);
		dispatch(AlertAction.Error(error));
	}
};


// IMP-210: 로직 lib/companyHierarchyService 로 이전. 호환 위해 위임.
const GetParents = getParents;

const GetParentsForRT = async () => {
	try {
		const cid = JSON.parse(localStorage.getItem('rtUser'))?.cId;
		const partners = await GetAllPartners();
		const scp = partners.find(x => x.cId === cid)?.sk.replace('scp:', '');

		if (scp !== '' && scp !== undefined) {
			const ret = await axios.get(AppConfig.GROUP_API_PATH + '/partner/getparents/' + scp, RT_TOKEN());
			if (ret.data.status === 'success')
				return ret.data.data;
			else
				return [];
		}
		else {
			return [];
		}
	} catch (error) {
		console.error("CompanyAction.GetParentsForRT error:", error);
		return [];
	}
}

const GetAllPartners = async () => {
	try {
		const data = {
			type: "getall",
			user: {
				companyInfo: {
					org: "hq"
				},
				scp: "0:"
			}
		};

		const ret = await axios.post(AppConfig.GROUP_API_PATH + '/partner', data, RT_TOKEN());

		if (ret.data.status === 'success') {
			return ret.data.data;
		} else {
			return [];
		}
	} catch (error) {
		console.error("CompanyAction.GetAllPartners error:", error);
		return [];
	}
}

const GetCombo = async (purpose) => {
	try {
		const isMegagen = JSON.parse(localStorage.getItem("user")).isMegagen;

		if (isMegagen) {
			const companies = await axios.get(AppConfig.API_SERVER_PATH + '/company', JWT());
			return (companies.data.status == 'success') ? (companies.data.data || []).map(x => { return { code: x.companyId, title: x.name } }).sort((a, b) => (a?.title || '').localeCompare(b?.title || '')) : [];
		} else {
			// IMP-381: purpose='create'(Add 화면) 시 BE 가 비-su 부모후보를 write scope 로 제한.
			const ret = await axios.post(AppConfig.API_SERVER_PATH + '/company', { type: "getcombo", purpose }, JWT());
			// IMP-378: 콤보 이름순 정렬 유지(원본 배열 불변)
			return (ret.data.status == 'success') ? [...(ret.data.data || [])].sort((a, b) => (a?.title || '').localeCompare(b?.title || '')) : [];
		}
	} catch (error) {
		console.error("CompanyAction.GetCombo error:", error);
		return [];
	}
}

const ClearUpdateResult = () => (dispatch) => {
	dispatch({ type: CompanyConstant.CLEAR_UPDATERES });
};

const GetReducer = (state) => {
	return state.CompanyReducer;
};

const GetCompanyLocal = async () => {
	try {
		const ret = await axios.get(AppConfig.API_SERVER_PATH + '/company', JWT());
		if (ret.data.status == 'success') {
			return ret.data.data;
		} else {
			return [];
		}
	} catch (error) {
		console.error("CompanyAction.GetCompanyLocal error:", error);
		return [];
	}

	// const partners = await GetAllPartners();

	// let data = [];

	// if (partners.length > 0) {
	// 	data = partners.map(x => {
	// 		return {
	// 			operator: x?.ops,
	// 			alias: x?.alias,
	// 			contactEmail: x?.cemail,
	// 			contactHp: x?.chp,
	// 			contactTel: x?.ctel,
	// 			contactFax: x?.cfax,
	// 			contactWebsite: x?.cweb,
	// 			createDate: x?.cd,
	// 			updateDate: x?.ud,
	// 			isDel: x?.isDel,
	// 			_id: x?._id,
	// 			companyId: x?.cId,
	// 			name: x?.nm,
	// 			country: x?.cnty,
	// 			org: x?.otype,
	// 			address: x?.address,
	// 			addressExtra: x?.addext,
	// 			state: x?.state,
	// 			zip: x?.zip,
	// 			region: x?.region,
	// 			note: x?.note,
	// 			ownername: x?.oname,
	// 			ownerhp: x?.ohp,
	// 			owneremail: x?.omail,
	// 			timezone: x?.tz,
	// 			lat: x?.coords?.length > 0 ? x.coords[0] : '',
	// 			lng: x?.coords?.length > 0 ? x.coords[1] : '',
	// 			parentCompanyId: x?.prntId,
	// 			companyTWId: x?.twId,
	// 			scp_1: parseInt(x?.sk?.replace('scp:', '').split(':')[0]),
	// 			scp_2: parseInt(x?.sk?.replace('scp:', '').split(':')[1]),
	// 			scp_3: parseInt(x?.sk?.replace('scp:', '').split(':')[2]),
	// 			// updater: x?.ud
	// 		}
	// 	}).sort((a, b) => {
	// 		if (a.scp_1 === b.scp_1) {
	// 			if (a.scp_2 === b.scp_2)
	// 				return (a.scp_3 < b.scp_3) ? -1 : (a.scp_3 > b.scp_3) ? 1 : 0;
	// 			else
	// 				return (a.scp_2 < b.scp_2) ? -1 : 1;
	// 		} else {
	// 			return (a.scp_1 < b.scp_1) ? -1 : 1;
	// 		}
	// 	});
	// }

	// return data;
};


export const CompanyAction = {
	GetCompany,
	GetCompanyByToken,
	GetCompanyInfo,
	GetCombo,
	AddCompanyInfo,
	UpdateCompanyInfo,
	DeleteCompany,
	ClearUpdateResult,
	GetCompanyLocal,
	GetReducer,
	GetParents,
	GetParentsForRT,
	GetAllPartners
};
